// dictionary.js

import fillterBarDictionary from "./data/fillterBarDictionary"

export {
  fillterBarDictionary
}